<script lang="ts">
  import { Feature } from '@do/models';

  import { useFlag } from '@shared/libs/unleash';

  const quidgetFlag = useFlag(Feature.UfdaQuidget);
</script>

<svelte:head>
  {#if $quidgetFlag}
    <script async src="https://w.quidget.ai/quidget.loader.js" data-id="91f27df1-11f8-4956-bb26-8612ff8c8ae1"></script>
  {/if}
</svelte:head>
